module.exports = __webpack_public_path__ + "img/icon-we-own-locations@3x.82084ba9.png";